module.exports = __webpack_public_path__ + "static/media/banjir.ae433140.jpeg";